import axiosInstance from '../axiosInterceptor/axiosInstance'

const getStatsGameSetup = async ({ gameId, skipErrorNotification = false }) => {
  const url = `/stats/games-setup/${gameId}`
  const response = await axiosInstance.get(url, { skipErrorNotification })
  return response?.data
}

export default getStatsGameSetup
